import { render, staticRenderFns } from "./options.vue?vue&type=template&id=4fc53406&"
import script from "./options.vue?vue&type=script&lang=js&"
export * from "./options.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports